import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

import type { IoniconIconName } from "@/schemas/icons";
import { themes } from "@/Components/Styling/themeConfigs";

export type CardStatus = "pending" | "active" | "completed";

export interface Props {
  status: CardStatus;
  title: string;
  subtitle: string;
  iconName: IoniconIconName;
}

function BaseUpdateCard({
  status,
  title,
  subtitle,
  iconName,
}: Props): React.JSX.Element {
  const currentTheme = themes.morning;

  const styles = StyleSheet.create({
    card: {
      backgroundColor: "white",
      borderRadius: 8,
      marginBottom: 8,
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.1,
      shadowRadius: 2,
      elevation: 1,
    },
    activeCard: {
      borderWidth: 1,
      borderColor: "#007AFF",
      shadowOpacity: 0.2,
      shadowRadius: 4,
      elevation: 3,
    },
    cardContent: {
      padding: 12,
      flexDirection: "row",
      alignItems: "center",
    },
    iconContainer: {
      width: 32,
      height: 32,
      borderRadius: 16,
      justifyContent: "center",
      alignItems: "center",
      marginRight: 12,
      backgroundColor: "#F5F5F5",
    },
    textContainer: {
      flex: 1,
      justifyContent: "center",
    },
    titleRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    titleText: {
      fontWeight: "600",
      fontSize: 14,
      color: currentTheme.typography.h1.color,
    },
    subtitleText: {
      fontSize: 12,
      marginTop: 2,
    },
    checkmark: {
      color: currentTheme.typography.h2.color,
      fontSize: 12,
      fontWeight: "bold",
    },
  });

  return (
    <View style={[styles.card, status === "active" && styles.activeCard]}>
      <View style={styles.cardContent}>
        <View style={styles.iconContainer}>
          <Ionicons name={iconName} size={16} />
        </View>
        <View style={styles.textContainer}>
          <View style={styles.titleRow}>
            <Text style={[styles.titleText]}>{title}</Text>
            {status === "completed" && <Text style={styles.checkmark}>✓</Text>}
          </View>
          {subtitle && <Text style={styles.subtitleText}>{subtitle}</Text>}
        </View>
      </View>
    </View>
  );
}

export default BaseUpdateCard;
